// removed by extract-text-webpack-plugin
module.exports = {"container":"ErrorScreen__container___pIw6W","errorIcon":"ErrorScreen__errorIcon___1TUN3","errorText":"ErrorScreen__errorText___1sBp5"};